import {Component, Input, OnInit} from '@angular/core';
import {FbAuctionConfiguration} from './fb-auction.configuration';

@Component({
    selector: 'fb-auction',
    templateUrl: './fb-auction.component.html',
    styleUrls: ['./fb-auction.component.scss']
})
export class FbAuctionComponent implements OnInit {

    @Input() configuration: FbAuctionConfiguration | null = null;



    constructor() {
    }

    ngOnInit() {
    }


}
